import React from 'react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/bulkPurchase/emptyNumbersCardStyle';
import TopUpIcon from 'assets/img/icons/top-up-img-small.svg';
import { BodyM, HeadingLBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import { useHistory } from 'react-router-dom';

// @ts-ignore
const useStyles = makeStyles(styles);

const EmptyNumbersScreen = ({ children, cancelScreen }: { children: React.ReactElement; cancelScreen: boolean }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleClick = (e: React.MouseEvent) => {
		e.preventDefault();
		history.push('/dashboard/purchase-bulk-devices/faq');
	};

	return (
		<Card className={classes.card}>
			<CardBody>
				<div className={classes.descriptionWrapper}>
					<img alt="Empty card icon" src={TopUpIcon} className={classes.image} />
					<HeadingLBold>{translate('purchase.bulk.devices.order.title')}</HeadingLBold>
					<BodyM disableMargin>
						{translate(
							cancelScreen
								? 'purchase.bulk.devices.order.description.cancel'
								: 'purchase.bulk.devices.order.description'
						)}
					</BodyM>
					<div className={classes.addNumberInputWrapper}>{children}</div>
					<a href="" onClick={(e) => handleClick(e)}>
						{translate('path.faq')}
					</a>
				</div>
			</CardBody>
		</Card>
	);
};

export default EmptyNumbersScreen;
